  <div class="dot-opacity-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>